<template>
  <el-row
    class="filter-container"
    :class="{'mt-custom-75': !isMobile}"
  >
    <el-row
      type="flex"
      justify="center"
    >
      <top-filter />
    </el-row>
    <el-row>
      <bread-crumb />
    </el-row>
    <el-row class="main-container">
      <el-col
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        style="max-width: 400px"
      >
        <left-filter />
      </el-col>
      <el-col
        class="ads1-container"
        :sm="11"
        :md="13"
        :lg="16"
        :xl="16"
      >
        <div
          v-if="attributeTypes && attributeTypes.length"
          class="badge-filters"
        >
          <badge-button :types="attributeTypes" />
        </div>
        <sort-ads />
        <entity-list
          ref="entityList"
          res="ads"
          :filter="getRequestFilters || []"
          :sort="getRequestSorts || []"
          :res-options="resourceOptions"
          :post-on-index="false"
        >
          <template
            slot="list"
            slot-scope="slotProps"
          >
            <ads
              :grid-col="gridCol"
              :items="slotProps.list"
              :ad-view-type="adViewType"
            />
          </template>
        </entity-list>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SortAds from '@/components/Ads/SortAds';
import Ads from '@/components/Ads/Ads';
import TopFilter from '@/components/TopFilter';
import BreadCrumb from '@/components/BreadCrumb';
import BadgeButton from '@/components/BadgeButton';
import LeftFilter from '@/components/MainLeftFilters/LeftFilter';
import EntityList from '@/components/Core/EntityList';
import { getAttributeTypes } from '@/store/filters/filters.getters';

export default {
  components: {
    EntityList,
    SortAds,
    Ads,
    LeftFilter,
    BadgeButton,
    TopFilter,
    BreadCrumb,
  },

  data() {
    return {
      resourceOptions: {
        file: true,
        currency: true,
        favoring_logged_in_user: true,
        contact_info: true,
        'category:parent': true,
      },
      gridCol: 12,
    };
  },

  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      category: state => state.filters.category,
      subcategory: state => state.filters.subcategory,
      sort: state => state.temp.sort,
      adViewType: state => state.ad_view_type,
    }),
    ...mapGetters([
      'getRequestFilters',
      'getRequestSorts',
    ]),
    attributeTypes() {
      const category = this.category;
      const subcategory = this.subcategory;
      return getAttributeTypes({ category, subcategory })
        .filter(item => !item.column_filter);
    },
  },

  watch: {
    // On filter change do a refresh
    getRequestFilters() {
      setTimeout(() => this.$refs.entityList.doRefresh());
    },
    getRequestSorts() {
      setTimeout(() => this.$refs.entityList.doRefresh());
    },
    isMobile: {
      immediate: true,
      handler(isMobile) {
        if (isMobile) {
          this.$router.push({ name: 'Home' });
        }
      },
    },
  },
};
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AdSearch.vue